import script from "./AdminFormElementTextNoSpace.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementTextNoSpace.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementTextNoSpace.vue?vue&type=style&index=0&id=aa0dafc6&lang=scss"

const __exports__ = script;

export default __exports__